import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { PageHeader } from "@shared/components/PageHeader";
import { Button } from "@shared/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@shared/ui/dialog";
import { useState } from "react";

export default function KpiPerformanceDashboard({ data }: { data: any }) {
  console.log(data);
  const [openModal, setOpenModal] = useState(false);
  const kpiCards = [
    {
      title: "Completion Rate",
      count: `${data?.metricsPercentages?.completionRate || 0}%`,
      tooltip:
        "% of meters that were successfully read. Low value suggests missed coverage.",
    },
    {
      title: "On‑Time Completion",
      count: `${data?.onTimeCompletionRate || 0}%`,
      tooltip:
        "% of meters read within the scheduled period; measures punctuality.",
    },
    {
      title: "Reading Accuracy",
      count: `${data?.metricsPercentages?.readingAccuracy || 0}%`,
      tooltip:
        "% of readings validated as accurate; low values may indicate field or device issues.",
    },
    {
      title: "Avg. Reading Time",
      count: `${data?.avgReadingTime || 0}`,
      tooltip:
        "Average time taken per meter reading; helps benchmark field productivity.",
    },
  ];
  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <PageHeader
            title="Performance KPIs"
            subtitle="The following KPIs reflect aggregated performance across all routes and meters in this read cycle."
          />
        </div>
        <div>
          <Button
            variant="outline"
            size="sm"
            className="justify-start p-2"
            onClick={() => setOpenModal(true)}
          >
            How it's Calculated
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-6">
        {kpiCards.map((card, index) => (
          <QuickStatsCard
            key={index}
            title={card.title}
            count={card.count}
            tooltip={card.tooltip}
            trendDirection={"up"}
          />
        ))}
      </div>
      <Dialog open={openModal} onOpenChange={setOpenModal}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-xl">Formulas</DialogTitle>
            <DialogDescription>
              Definitions used across the Performance dashboard.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-3 text-sm">
            <div>
              <span className="font-semibold">Completion Rate:</span> (Meters
              Read ÷ Total Meters) × 100
            </div>
            <div>
              <span className="font-semibold">On‑Time Completion:</span> (Meters
              Read On Time ÷ Total Meters) × 100
            </div>
            <div>
              <span className="font-semibold">Reading Accuracy:</span> (Accurate
              Readings ÷ Total Readings) × 100
            </div>
            <div>
              <span className="font-semibold">Avg. Reading Time:</span> Total
              Reading Time ÷ Total Meters Read
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
